import MainPageView from "../views/MainPageView.vue";

export const MainPageRouters = [
    {
        path: "/",
        name: "MainPageView",
        components: {
            default: MainPageView,
        },
    },
];
